module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Down_16"],"polygon":[{"$":{"points":"8 12.48 1.76 5.68 3.24 4.32 8 9.52 12.76 4.32 14.24 5.68 8 12.48","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Down_16.svg
// module id = XpGT
// module chunks = 1